import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    setSuccess("Password changed successfully!");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f0f0f0", // optional background
      }}
    >
      <Box
        sx={{
          maxWidth: "400px",
          width: "100%",
          p: "30px",
          borderRadius: "8px",
          backgroundColor: "#FAF9F8",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          fontFamily: "inherit",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            fontSize: "24px",
            mb: 3,
            color: "#333",
          }}
        >
          Change Password
        </Typography>
        <form onSubmit={handleSubmit}>
          <Box mb={2}>
            <Typography
              sx={{
                display: "block",
                fontWeight: 600,
                mb: 1,
                color: "#555",
              }}
            >
              Old Password *
            </Typography>
            <TextField
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Old password"
              required
              fullWidth
              size="small"
            />
          </Box>

          <Box mb={2}>
            <Typography
              sx={{
                display: "block",
                fontWeight: 600,
                mb: 1,
                color: "#555",
              }}
            >
              New Password *
            </Typography>
            <TextField
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="New password"
              required
              fullWidth
              size="small"
            />
          </Box>

          <Box mb={2}>
            <Typography
              sx={{
                display: "block",
                fontWeight: 600,
                mb: 1,
                color: "#555",
              }}
            >
              Confirm Password *
            </Typography>
            <TextField
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm password"
              required
              fullWidth
              size="small"
            />
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2, fontSize: "14px" }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2, fontSize: "14px" }}>
              {success}
            </Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#000",
              color: "#fff",
              padding: "12px",
              fontSize: "16px",
              borderRadius: "4px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#222",
              },
            }}
          >
            Change Password
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default ChangePassword;
